import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import { ScrollView } from "react-native";
import { Button } from "~/components/Button";
import { Spacer } from "~/components/Spacer";
import { Text } from "~/components/Text";
import { View } from "~/components/View";
import { styleConstants as C, styleConstants } from "~/style/styleConstants";
import { Icon } from "./Icon";

export const ErrorView = observer(function ErrorView({
  error,
  title,
  body,
}: {
  error: unknown;
  title?: string;
  body?: string | React.ReactNode | React.ReactNode[];
}) {
  const [isErrorVisible, setIsErrorVisible] = useState(false);

  return (
    <View paddingExtraLarge>
      <View centerContent>
        <Icon
          name="heart-broken-outline"
          size={100}
          color={styleConstants.colorBackgroundTheme}
        />
      </View>
      <Spacer large />

      <Text alignCenter sizeLarge weightSemiBold>
        {title ??
          intl.formatMessage({
            id: "HYP1NC",
            defaultMessage: "Something went wrong",
            description: "Error view title",
          })}
      </Text>

      {!!body && <Spacer />}

      {typeof body === "string" ? <Text alignCenter>{body}</Text> : body}

      {!!body && <Spacer small />}

      <Button small transparent onPress={() => setIsErrorVisible((n) => !n)}>
        <Text sizeExtraSmall colorTheme weightSemiBold>
          {isErrorVisible
            ? intl.formatMessage({
                defaultMessage: "Hide details",
                id: "k+3605",
                description: "Error view button to hide details of error",
              })
            : intl.formatMessage({
                defaultMessage: "More details",
                description:
                  "Error view button to show details of error. Shown on ErrorView",
                id: "SC1QGN",
              })}
        </Text>
      </Button>

      <Spacer />
      {isErrorVisible && (
        <View
          alignSelfStretch
          borderRadiusMedium
          style={{ overflow: "hidden" }}
        >
          <ScrollView style={{ maxHeight: 300 }} bounces={false}>
            <ScrollView
              horizontal
              contentContainerStyle={{
                backgroundColor: C.colorBackgroundLightDark,
                minWidth: "100%",
                padding: C.spacingMedium,
              }}
              bounces={false}
              showsHorizontalScrollIndicator={false}
              showsVerticalScrollIndicator={false}
            >
              <Text>{String(error)}</Text>
            </ScrollView>
          </ScrollView>
        </View>
      )}
    </View>
  );
});

export function DefaultErrorView({
  query,
  title,
}: {
  query: { error: unknown; refetch: () => any };
  title?: string | undefined;
}) {
  return (
    <ErrorView
      title={title}
      error={query.error}
      body={
        <View centerContent>
          <Spacer large />
          <Button
            style={{ minWidth: 200 }}
            small
            title={intl.formatMessage({
              id: "1xUker",
              defaultMessage: "Retry",
              description: "Error view button to retry a failed query",
            })}
            onPress={() => {
              return query.refetch();
            }}
          />
        </View>
      }
    />
  );
}
